export default "__VITE_ASSET__4natsuyz__"